import { useState } from 'react';
import { Toast } from '@/components/ui/Toast';
import { SQIcon } from '@/components/ui/SQIcon';
import { runtime } from '@/platform/runtime';
import { getTelegramWebApp } from '@/platform/telegram';
import styles from './InviteBlock.module.css';

export function InviteBlock({ code }: { code: string }) {
  const [copied, setCopied] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);

  const standaloneUrl = `${window.location.origin}/r/${code}`;
  const tgDeepLink = `https://t.me/skvoz_bot?startapp=${code}`;

  const share = () => {
    const text = encodeURIComponent(`Заходи в «Сквозь»: код ${code}`);
    const url = encodeURIComponent(tgDeepLink);
    const shareUrl = `https://t.me/share/url?url=${url}&text=${text}`;
    const tg = getTelegramWebApp();
    if (tg?.openTelegramLink) {
      tg.openTelegramLink(shareUrl);
    } else {
      window.open(shareUrl, '_blank');
    }
  };

  const copy = async () => {
    await navigator.clipboard.writeText(standaloneUrl);
    setCopied(true);
    setToastOpen(true);
    setTimeout(() => setCopied(false), 1600);
  };

  const displayUrl = `${window.location.hostname}/r/${code}`;

  return (
    <div className={styles.card}>
      <p className={styles.heading}>Позови друзей</p>
      <div className={styles.linkRow}>
        <span className={styles.linkText}>{displayUrl}</span>
        <button className={styles.copyBtn} onClick={copy} aria-label="Копировать ссылку">
          {copied ? '✓' : 'Копировать'}
        </button>
      </div>
      {!runtime.isMiniApp && (
        <Toast
          open={toastOpen}
          onOpenChange={setToastOpen}
          title="Скопировано"
          variant="success"
          duration={2000}
        />
      )}
      <button className={styles.shareBtn} onClick={share}>
        <SQIcon name="send" size={16} />
        <span>Поделиться через Telegram</span>
      </button>
    </div>
  );
}
